import { getCookie } from "./cookies";

/** Safe on server (returns null); use in client components only for real reads. */
export function getAccessToken() {
  if (typeof window === "undefined") return null;
  return getCookie("access_token");
}
